/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileWav = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="m9.455 15.362.9-3.102h.89l.936 3.065.707-3.342h1.062L12.84 17h-1.034l-1.03-3.377L9.804 17H8.769l-1.112-5.017h1.09zM18.706 17h-1.2l-.332-1.028h-1.852L14.994 17h-1.152l1.904-5.017h1.042zm-3.093-1.938h1.267l-.638-1.973zm5.024.614 1.185-3.693h1.166L21.14 17h-1.042l-1.85-5.017h1.215z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileWav as FileWav };
